import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPreview = () => {
  const { t, lang } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/blog`)
      .then((res) => {
        if (mounted) setPosts(res.data || []);
      })
      .catch(() => {
        if (mounted) setPosts([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (posts.length === 0) return null;

  return (
    <section
      id="blog"
      data-testid="blog-section"
      className="section-padding bg-[#F8FAFC]"
    >
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="chip mb-5">{t.blog.eyebrow}</span>
            <h2
              data-testid="blog-title"
              className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
            >
              {t.blog.title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
              {t.blog.lead}
            </p>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="link-underline self-start md:self-auto"
          >
            {t.blog.viewAll}
            <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((post) => (
            <article
              key={post.id}
              data-testid={`blog-card-${post.slug}`}
              className="group rounded-2xl overflow-hidden border border-border bg-white card-hover"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={post.image}
                    alt={lang === "fr" ? post.title_fr : post.title_en}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                    width="1200"
                    height="750"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
                    <span className="text-[#FF5A1F]">
                      {lang === "fr" ? post.category_fr : post.category_en}
                    </span>
                    <span>·</span>
                    <span>{post.read_time} {t.blog.minRead}</span>
                  </div>
                  <h3 className="mt-3 font-display text-xl font-bold text-navy leading-tight group-hover:text-[#FF5A1F] transition-colors">
                    {lang === "fr" ? post.title_fr : post.title_en}
                  </h3>
                  <p className="mt-3 text-sm text-foreground/70 leading-relaxed line-clamp-3">
                    {lang === "fr" ? post.excerpt_fr : post.excerpt_en}
                  </p>
                  <span className="mt-5 link-underline text-sm">
                    {t.blog.readMore}
                    <i className="fa-solid fa-arrow-right text-[11px]" aria-hidden="true"></i>
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
